export default {
  setViewDataGrid(state, value) {
    state.demandDataGrid = value
  },
  setViewDataList(state, value) {
    state.demandDataList = value
  }
}
